// extracted by mini-css-extract-plugin
export var animatedGraphic = "styles-module--animatedGraphic--2b624";
export var borderMask = "styles-module--borderMask--8d65c";
export var container = "styles-module--container--4ca4d";